// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "lopension-react-pension-calculator." + "42aa6b94" + ".chunk.js";
};